import React from "react";
import { Select} from "antd";
import axios from "axios";
// import Chat from "./Chat";
// import AdminChat from "./AdminChat";
import { Row, Col } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars-2";

import classes from "./PayrollPageExtra.module.css";
// import "./PayrollPage.css";
import {  Layout } from "antd";
import { GlobalOutlined } from '@ant-design/icons';
import SiderContentS from "../../components/PurchaseModule/SiderContentS/SiderContentS";
// import Sidebar from "./Sidebar/Sidebar";
// import Main from "./Main/Main";
import { useEffect, useState } from "react";
import FieldDataS from "../../components/PurchaseModule/FieldDataS/FieldDataS";

import { DataProvider } from "../../Context/dataContext";


const {  Content, Sider } = Layout;
const { Option } = Select;

const StockModule = (props) => {
  // console.log(props, "props in purchase");

  const history = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(true);
  const [miscList, setMiscList] = useState(null);
  const [userList, setUserList] = useState(null);
  const [currentModule, setCurrentModule] = useState("Procurement Management");
  const [currentSite, setCurrentSite] = useState();
  const [currentFinYear, setCurrentFinYear] = useState();
  // Extract state if it exists

  // // console.log(userData.data.user, "uuuuuuuuuuuuuuuuuuuuuuuuuuuuuu");
  const onCollapse = (collapsed) => {
    setCollapsed(collapsed);
  };

  const employeeData = {
    URL: props.url,
    miscList: miscList,
    finyear1: props.finyear || currentFinYear,
    permission: userList,
    currentSite: currentSite
  };

  useEffect(() => {
    axios
      .get(props.url + "/api/v1/purchaseorder/chat-bot-icon", {
        withCredentials: true,
      })
      .then((response) => {
         console.log(response.data.data, "ssssssssssssssssss");
        const newList = response.data.data;
        const siteRows = newList?.unit?.rows || [];
        if (siteRows.length > 0) setCurrentSite(siteRows[0].site_code);
        if (newList?.year?.rows.length > 0) setCurrentFinYear(newList.year.rows[0].year_nm);
        setUserList(newList);
      })
      .catch((err) => {});
  }, []);


   const handleModuleChange = (value) => {
      axios.post(props.url + "/api/v1/users/update-usertype", { user_type: value }, { withCredentials: true })
        .then((res) => {
          const newToken = res.data.token;
          if (newToken) localStorage.setItem("token", newToken);
          if (value === "Sales") history("/sales/dashboard");
          if (value === "Job Work") history("/jobwork/dashboard");
          if (value === "Stock Control") history("/stock/dashboard");
          if (value === "Payroll") history("/payroll/dashboard");
          if (value === "Production") history("/production/dashboard");
          if (value === "Financial Management") history("/finance/dashboard");
          if (value === "Gate Control") history("/gate/dashboard");
          if (value === "Trasporter") history("/transporter/dashboard");
          if (value === "Administrator Module") history("/admin/dashboard");
          setCurrentModule(value);
        })
        .catch((error) => {
          console.error("Error updating user type:", error);
        });
    };
  
    const handleFinYearChange = (value) => {
      setCurrentFinYear(value);
    };
  
    const handleSiteChange = (value) => {
      setCurrentSite(value);
      axios.post(props.url + "/api/v1/users/update-unit", { newUnit: value }, { withCredentials: true })
        .then((res) => {
          const newToken = res.data.token;
          localStorage.setItem("token", newToken);
        })
        .catch(error => {
          console.error("Error updating unit:", error);
        });
    };

  return (
    <Layout style={{ minHeight: "100vh", backgroundColor: "transparent" }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={onCollapse}
        style={{ backgroundColor: "transparent" }}
      >
        <SiderContentS url={props.url} miscList={miscList} />
      </Sider>

      <Layout className={classes["SiteLayout"]}>
        <Scrollbars>
        <Row className={classes["header-row"]} align="middle" justify="space-between">
            <Col xs={18} md={16} lg={16} className={classes["global-controls"]}>
              <div className={classes["header-content"]}>
                <Row gutter={[16, 0]} align="middle" style={{ width: "100%" }}>
                <Col xs={24} sm={6} lg={6}>
  <div className={classes["selector-container"]}>
    <div className={classes["selector-label"]}>
      <GlobalOutlined />
    </div>
    <Select
      placeholder="Change Module"
      style={{ width: "100%" }}
      onChange={handleModuleChange}
      size="small"
      value={currentModule}
      disabled={location.pathname !== "/purchase/dashboard"}
    >
      {employeeData?.permission?.module?.rows?.map((module) => (
        <Option key={module.module_id} value={module.module_name}>
          {module.module_name}
        </Option>
      ))}
    </Select>
  </div>
</Col>


                  <Col xs={24} sm={6} lg={6}>
                    <div className={classes["selector-container"]}>
                      <Select
                        placeholder="Change Site"
                        style={{ width: "100%" }}
                        onChange={handleSiteChange}
                        size="small"
                        value={currentSite}
                        disabled={location.pathname !== "/purchase/dashboard"}
                      >
                        {employeeData?.permission?.unit?.rows?.map((site) => (
                          <Option key={site.site_code} value={site.site_code}>
                            {site.site_desc}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </Col>

                  <Col xs={24} sm={6} lg={6}>
                    <div className={classes["selector-container"]}>
                      <Select
                        placeholder="Fin Year"
                        style={{ width: "100%" }}
                        onChange={handleFinYearChange}
                        size="small"
                        value={currentFinYear}
                        disabled={location.pathname !== "/purchase/dashboard"}
                      >
                        {employeeData?.permission?.year?.rows?.map((year) => (
                          <Option key={year.year_nm} value={year.year_nm}>
                            {year.year_desc}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>

            <Col xs={6} md={8} lg={8} className={classes["info-container"]}>
              <div className={classes["company-info"]}>
                <p className={classes["first-item"]}>
                  {userList && userList.OpenningValue.rows[0].company_name}
                </p>
              </div>
              <div className={classes["unit-info"]}>
                <p className={classes["text"]}>
                  ({userList && userList.user[0].spec_code})
                </p>
              </div>
            </Col>
          </Row>
          <DataProvider value={employeeData}>
            <Content>
              <FieldDataS />
            </Content>
          </DataProvider>
        </Scrollbars>
      
      </Layout>
    </Layout>
  );
};

export default StockModule;
